/**
 * App breadcrumb Object
 *
 * @type object
 */
App.breadcrumb = {

    /**
     * Constructor Function
     *
     * Boot function
     */
    init: function() {

    },

    /**
     * Get breadcrumb height
     *
     * @returns {*|jQuery}
     */
    getHeight: function() {
        return $('main .breadcrumbs').outerHeight();
    },


    /**
     * Handle breadcrumb height
     */
    handleHeight: function() {

    }
};